import { CollectionTemplateDefinitionCollection } from '@indigohive/cogfy-types'
import { FolderIcon, TableIcon } from 'lucide-react'

type IconComponentType = typeof TableIcon
export type CollectionTemplateType = CollectionTemplateDefinitionCollection['type']

export const COLLECTION_ICON_BY_TYPE: Record<CollectionTemplateType, IconComponentType> = {
  database: TableIcon,
  folder: FolderIcon
}
